import { render } from "./group.vue?vue&type=template&id=50ea4975&scoped=true"
import script from "./group.vue?vue&type=script&lang=js"
export * from "./group.vue?vue&type=script&lang=js"

import "./group.vue?vue&type=style&index=0&id=50ea4975&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ea4975"]])

export default __exports__